import React, { memo } from 'react'
import { Avatar } from '@material-ui/core'

export default memo(({ icon, variant = 'circular', ...props }) => (
  <Avatar variant={variant} {...props}>
    {icon}
  </Avatar>
))
